import { HomePage } from './home.component';
import { connect } from 'react-redux';
import { fetchHomeProducts, addToWishlist, removeToWishlist } from "./../../api/product/productAction";
import { addToCart } from "./../../api/cart/cartAction";

const mapDispatchToProps = {
    fetchHomeProducts,
    addToCart,
    addToWishlist,
    removeToWishlist
};

const mapStateToProps = state => ({
    isLoading: state.productPage.isLoading,
    home: state.productPage.home,
    isAdded: state.productPage.isAdded,
    isLoggedIn: state.userPage.isLoggedIn
});

export const HomeContainer = connect(mapStateToProps, mapDispatchToProps)(HomePage);